/**
 * Waiting, shown where the wait is (2026-10-13).
 *
 *   <Spinner />             a ring, sized to the text around it
 *   <Loading label="…" />   a ring and a line, centred in the space it fills:
 *                           a whole screen while a family opens, or one
 *                           section while its part loads
 *
 * Saving shows on the button that saved (`aria-busy` on it draws the ring,
 * living-valley.css 42) and dims the section being saved. Menus and
 * navigation never wait, so they never spin.
 */
export function Spinner({ size, className }: { size?: number; className?: string }) {
  return (
    <span
      className={className ? `spinner ${className}` : 'spinner'}
      style={size ? { width: size, height: size } : undefined}
      aria-hidden="true"
    />
  );
}

export function Loading({ label, fill = false }: { label: string; fill?: boolean }) {
  return (
    <div className={fill ? 'loading loading-fill' : 'loading'} role="status" aria-live="polite">
      {/* A whole-screen wait sits on its own dark card, so it reads on the
          cream sheet and on the painting alike. */}
      <div className={fill ? 'loading-card' : 'loading-inline'}>
        <Spinner size={fill ? 44 : 30} />
        <p className="loading-label">{label}</p>
      </div>
    </div>
  );
}
